/* eslint-disable no-undef */
import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { DialogContent } from '@mui/material'
import { Elements } from '@stripe/react-stripe-js'
import PropTypes from 'prop-types'
import initStripe from 'services/Stripe'

import PaymentAPI from '../../../api/orbitV1/PaymentAPI'

import StripeCheckoutForm from './StripeCheckoutForm'

export default function StripeForm({
  orgId,
  email,
  amountPayable,
  setDialogOpen,
  handleNext,
  handleBack,
  metaInfo,
  variant
}) {
  const [stripePromise, setStripePromise] = useState(null)
  const [options, setOptions] = useState({})
  const [payIntentOpen, setPayIntentOpen] = useState(false)

  // stripe public key
  useEffect(() => {
    initStripe().then((res) => {
      setStripePromise(res)
    })
  }, [])

  useEffect(() => {
    if (!payIntentOpen) {
      createPaymentIntent(orgId, amountPayable)
    }
  }, [])

  const createPaymentIntent = async (customerId, paymentAmount) => {
    try {
      const paymentIntent = await PaymentAPI.createPayInt({
        customerId,
        paymentAmount,
        email,
        orderNo: metaInfo.data.orderNo,
        type: 'order',
        pricePackage: {
          currency: 'sgd',
          value: paymentAmount,
          symbol: '$'
        },
        service: 'orbit'
      })
      if (paymentIntent.data) {
        setOptions({
          // passing the client secret obtained in step 2
          clientSecret: paymentIntent.data.client_secret,
          // Fully customizable with appearance API.
          appearance: {
            theme: 'flat'
          }
        })
        setPayIntentOpen(true)
      }
    } catch (error) {
      toast.error('Error making payment. Please try again later!')
    }
  }

  return (
    <>
      <DialogContent>
        {payIntentOpen && (
          <Elements stripe={stripePromise} options={options}>
            <StripeCheckoutForm
              handleNext={handleNext}
              setDialogOpen={setDialogOpen}
              setPayIntentOpen={setPayIntentOpen}
              handleBack={handleBack}
              variant={variant}
            />
          </Elements>
        )}
      </DialogContent>
    </>
  )
}

StripeForm.propTypes = {
  orgId: PropTypes.string,
  email: PropTypes.string,
  amountPayable: PropTypes.number,
  setDialogOpen: PropTypes.func,
  handleNext: PropTypes.func,
  handleBack: PropTypes.func,
  metaInfo: PropTypes.object,
  variant: PropTypes.string
}
